module.exports = __webpack_public_path__ + "3955153a843eef5026213447a4a0cbc3.fbx";